export default __webpack_public_path__ + "integrations-nudge-bg.png";